import axios from '../axios'
import { Logging, LoggingCode } from '../helpers/types/logging'

export interface FetchLoggingsOptions {
	onlyErrors?: boolean
}

export interface CreateLoggingCodePayload {
	code: string
	text: string
	type: string
	source: string
	isError: boolean
	notify: boolean
}

export type UpdateLoggingCodePayload = Partial<
	Omit<CreateLoggingCodePayload, 'code'>
>

export const fetchCarrierLoggings = async (
	carrierId: number,
	options: FetchLoggingsOptions = {}
) => {
	const { data } = await axios.get('/api/v1/logging', {
		headers: {
			'x-carrier-id': carrierId
		},
		params: options.onlyErrors ? { onlyErrors: true } : undefined
	})
	return data as Logging[]
}

export const fetchAllLoggings = async (
	options: FetchLoggingsOptions = {}
) => {
	const { data } = await axios.get('/api/v1/logging/all', {
		params: options.onlyErrors ? { onlyErrors: true } : undefined
	})
	return data as Logging[]
}

export const fetchLoggingCodes = async () => {
	const { data } = await axios.get('/api/v1/logging/codes/all')
	return data as LoggingCode[]
}

export const createLoggingCode = async (
	payload: CreateLoggingCodePayload
) => {
	const { data } = await axios.post(
		'/api/v1/logging/codes',
		payload
	)
	return data as LoggingCode
}

export const updateLoggingCode = async (
	code: string,
	payload: UpdateLoggingCodePayload
) => {
	const { data } = await axios.patch(
		`/api/v1/logging/codes/${encodeURIComponent(code)}`,
		payload
	)
	return data as LoggingCode
}

export const deleteLoggingCode = async (code: string) => {
	await axios.delete(
		`/api/v1/logging/codes/${encodeURIComponent(code)}`
	)
}
